import { render, staticRenderFns } from "./User-phone-new.vue?vue&type=template&id=af47526e&scoped=true&"
import script from "./User-phone-new.vue?vue&type=script&lang=js&"
export * from "./User-phone-new.vue?vue&type=script&lang=js&"
import style0 from "./User-phone-new.vue?vue&type=style&index=0&id=af47526e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af47526e",
  null
  
)

export default component.exports